import { PreviewModal } from '~/features/shared/components/preview-modal'
import * as m from '~/paraglide/messages'
import { ListingPreview } from './listing-preview'

interface ListingPreviewModalProps {
  name: string
  description: string
  location: {
    name?: string
    street: string
    city: string
    country: string
  }
  phone?: string
  coverImageUrl?: string
  onFieldClick?: (fieldName: string) => void
}

export function ListingPreviewModal({
  name,
  description,
  location,
  phone,
  coverImageUrl,
  onFieldClick,
}: ListingPreviewModalProps) {
  return (
    <PreviewModal
      title={m.listingPreview()}
      description={m.thisIsHowYourListingWillAppearToUsers()}
      onFieldClick={onFieldClick}
    >
      {(handleFieldClick) => (
        <ListingPreview
          name={name}
          description={description}
          location={location}
          phone={phone}
          coverImageUrl={coverImageUrl}
          onFieldClick={handleFieldClick}
        />
      )}
    </PreviewModal>
  )
}
